package org.example.project.engineletter

import androidx.compose.runtime.Composable
import org.example.project.engineletter.layouts.sys.SysTextToPdfPalettenkontoabschlussLayout
import org.example.project.engineletter.layouts.sys.SysTextToPdfWAPalettenscheinLayout
import org.example.project.engineletter.layouts.sys.SysTextToPdfWAQualitaetsdokumentationLayout
import org.example.project.engineletter.layouts.sys.SysTextToPdfWAVorgangslogLayout
import org.example.project.engineletter.layouts.sys.SysTextToPdfWEPalettenscheinLayout
import org.example.project.engineletter.layouts.sys.SysTextToPdfWEProzessdokumentationLayout
import org.example.project.engineletter.layouts.sys.SysTextToPdfWEQualitaetsdokumentationLayout
import org.example.project.engineletter.layouts.sys.SysTextToPdfWEWareneingangsberichtLayout
import org.example.project.engineletter.layouts.sys.SysTextToPdfRechnungslayout
import org.example.project.utils.All

@Composable
fun RenderSysTextToPdfLayout(
    rootElementId: String? = null,
    layoutKey: String,
    auftrag: All?,
    vorgangslog: List<All>,
    unternehmen: All,
    logoSrc: String,
    kontrollDefinitionen: List<All> = emptyList(),
    webKontrolle: All? = null,
    kunde: All = All(),
    currentSysUser: All = All(),
    editable: Boolean = false
) {
    val source = auftrag ?: All(auftragsart = if (layoutKey.endsWith("_WE")) "WE" else "WA")
    when (layoutKey) {
        LETTER_LAYOUT_PALSCHEIN_WE -> SysTextToPdfWEPalettenscheinLayout(rootElementId, source, unternehmen, logoSrc, editable = editable)
        LETTER_LAYOUT_PALSCHEIN_WA -> SysTextToPdfWAPalettenscheinLayout(rootElementId, source, unternehmen, logoSrc, editable = editable)
        LETTER_LAYOUT_DOKUMENTATION_WE -> SysTextToPdfWEProzessdokumentationLayout(rootElementId, source, vorgangslog, unternehmen, logoSrc, kontrollDefinitionen, editable)
        LETTER_LAYOUT_DOKUMENTATION_WA -> SysTextToPdfWAVorgangslogLayout(rootElementId, source, vorgangslog, unternehmen, logoSrc, kontrollDefinitionen, editable)
        LETTER_LAYOUT_QUALITAET_WE -> SysTextToPdfWEQualitaetsdokumentationLayout(rootElementId, source, unternehmen, logoSrc, kontrollDefinitionen)
        LETTER_LAYOUT_QUALITAET_WA -> SysTextToPdfWAQualitaetsdokumentationLayout(rootElementId, source, unternehmen, logoSrc, kontrollDefinitionen)
        LETTER_LAYOUT_QUALITAET_WE_BERICHT -> SysTextToPdfWEWareneingangsberichtLayout(rootElementId, source, webKontrolle ?: All(), unternehmen, logoSrc)
        LETTER_LAYOUT_PALETTENKONTOABSCHLUSS -> SysTextToPdfPalettenkontoabschlussLayout(rootElementId, source, unternehmen, logoSrc)
        LETTER_LAYOUT_RECHNUNG_SYS -> SysTextToPdfRechnungslayout(rootElementId, source, kunde, unternehmen, logoSrc, currentSysUser, editable)
    }
}
